module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_02@2x-2075c2885df4e7ec3e5eab8a2a061b2b.jpg";